import Microgame from '../engine/Microgame.js';

export default class MagnetGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Aimant !`, en: `Magnet!`, es: `¡Imán!` },
            controls: { fr: `Maintiens appuyé pour activer l'aimant`, en: `Hold to activate the magnet`, es: `Mantén presionado para activar el imán` },
            objective: { fr: `Attire les bons objets magnétiques`, en: `Attract the correct magnetic objects`, es: `Atrae los objetos magnéticos correctos` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M5 9V7a7 7 0 0 1 14 0v2"/><path d="M3 9h4v6H3z"/><path d="M17 9h4v6h-4z"/></svg>`,
            actions: [
                { type: 'hold', x: 50, y: 50, holdDuration: 300 },
                { type: 'hold', x: 28, y: 22, holdDuration: 360 },
                { type: 'wait', duration: 100 },
                { type: 'hold', x: 72, y: 22, holdDuration: 360 },
                { type: 'wait', duration: 100 },
                { type: 'hold', x: 20, y: 72, holdDuration: 360 },
                { type: 'wait', duration: 100 },
                { type: 'hold', x: 80, y: 72, holdDuration: 360 },
                { type: 'wait', duration: 100 },
                { type: 'hold', x: 50, y: 80, holdDuration: 420 },
                { type: 'wait', duration: 500 },
            ],
            loopDuration: 4000
        };
    }
    constructor(engine) {
        super(engine);
        this.magnet = null;
        this.items = [];
        this.score = 0;
        
        const speedMult = engine.speedMultiplier || 1.0;
        const adj = 1 + (speedMult - 1) * 0.3;
        this.duration = 4200 * (speedMult / adj);

        // All good items must be collected to win
        this.targetScore = 5; 
        
        if (this.engine.activeChallenge && this.engine.activeChallenge.config && this.engine.activeChallenge.config.targetScore) {
            this.targetScore = this.engine.activeChallenge.config.targetScore;
        }
    }

    setup() {
        this.engine.ui.instruction.textContent = "COLLECT!";
        this._spawnIdx = 0;

        // Magnet (Follows input)
        this.magnet = document.createElement('div');
        this.magnet.style.position = 'absolute';
        this.magnet.style.width = '60px';
        this.magnet.style.height = '60px';
        this.magnet.style.background = this.primaryColor;
        this.magnet.style.boxShadow = `0 0 15px ${this.primaryColor}`;
        this.magnet.style.borderRadius = '50% 50% 0 0'; // Horseshoe shape
        this.magnet.style.left = '50%';
        this.magnet.style.top = '50%';
        this.magnet.style.transform = 'translate(-50%, -50%)';
        this.magnet.style.pointerEvents = 'none';
        this.magnet.style.zIndex = '10';
        this.container.appendChild(this.magnet);

        // Spawn Items
        for (let i = 0; i < this.targetScore; i++) {
            this.spawnItem('good');
        }
        for (let i = 0; i < 3; i++) {
            this.spawnItem('bad');
        }

        // Input
        this.isDragging = false;
        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);

        this.engine.input.element.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
        this.engine.input.element.addEventListener('pointercancel', this.onUp);
    }

    spawnItem(type) {
        const item = document.createElement('div');
        const size = 20;

        let x, y;
        let isTooClose = true;
        let attempts = 0;
        while (isTooClose && attempts < 50) {
            attempts++;
            if (this.isPlayback) {
                const goodSpots = [
                    { x: 28, y: 22 },
                    { x: 72, y: 22 },
                    { x: 20, y: 72 },
                    { x: 80, y: 72 },
                    { x: 50, y: 80 }
                ];
                const badSpots = [
                    { x: 84, y: 14 },
                    { x: 14, y: 14 },
                    { x: 50, y: 12 }
                ];
                const arr = type === 'good' ? goodSpots : badSpots;
                const idx = this._spawnIdx % arr.length;
                x = arr[idx].x;
                y = arr[idx].y;
                this._spawnIdx++;
            } else {
                x = Math.random() * 80 + 10;
                y = Math.random() * 80 + 10;
            }
            const distCenter = Math.hypot(x - 50, y - 50);
            if (distCenter < 18) continue;

            // Check distance from other items to avoid impossible overlaps
            let overlaps = false;
            for (const other of this.items) {
                const ox = parseFloat(other.element.style.left);
                const oy = parseFloat(other.element.style.top);
                if (Math.hypot(x - ox, y - oy) < 15) { // 15% min distance between centers
                    overlaps = true;
                    break;
                }
            }
            if (!overlaps) isTooClose = false;
        }

        item.style.position = 'absolute';
        item.style.width = `${size}px`;
        item.style.height = `${size}px`;
        item.style.left = `${x}%`;
        item.style.top = `${y}%`;
        item.style.transform = 'translate(-50%, -50%)';

        if (type === 'good') {
            item.style.borderRadius = '50%';
            item.style.background = this.secondaryColor;
            item.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
            item.dataset.type = 'good';
        } else {
            item.style.borderRadius = '0';
            item.style.background = 'none';
            // Cross shape
            item.innerHTML = `
                <div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(45deg);width:20px;height:4px;background:#ff0000;box-shadow:0 0 5px #ff0000;border-radius:2px;"></div>
                <div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(-45deg);width:20px;height:4px;background:#ff0000;box-shadow:0 0 5px #ff0000;border-radius:2px;"></div>
            `;
            item.dataset.type = 'bad';
        }

        this.container.appendChild(item);
        this.items.push({ element: item, active: true, type: item.dataset.type });
    }

    onDown(e) {
        if (!this.active) return;
        const rect = this.container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Check if clicking near magnet (using actual center in pixels)
        const mx = this.magnet.offsetLeft + this.magnet.offsetWidth / 2;
        const my = this.magnet.offsetTop + this.magnet.offsetHeight / 2;
        const dist = Math.hypot(x - mx, y - my);

        if (dist < 100) { // Large tolerant radius for easy pickup
            this.isDragging = true;
            this.magnet.style.transform = 'translate(-50%, -50%) scale(1.2)';
            this.magnet.style.filter = 'brightness(1.5)';
        }
    }

    onUp() {
        this.isDragging = false;
        if (this.magnet) {
            this.magnet.style.transform = 'translate(-50%, -50%) scale(1)';
            this.magnet.style.filter = 'none';
        }
    }

    onMove(e) {
        if (!this.active || !this.isDragging) return;

        const rect = this.container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Clamp to container
        const clampedX = Math.max(0, Math.min(rect.width, x));
        const clampedY = Math.max(0, Math.min(rect.height, y));

        this.magnet.style.left = `${clampedX}px`;
        this.magnet.style.top = `${clampedY}px`;

        // Check collisions
        this.items.forEach(item => {
            if (!item.active) return;

            const ix = parseFloat(item.element.style.left) / 100 * rect.width;
            const iy = parseFloat(item.element.style.top) / 100 * rect.height;

            const dist = Math.hypot(clampedX - ix, clampedY - iy);

            if (dist < 50) { // Magnet range
                // Pull effect
                const angle = Math.atan2(clampedY - iy, clampedX - ix);
                const speed = 5;
                const nx = ix + Math.cos(angle) * speed;
                const ny = iy + Math.sin(angle) * speed;

                item.element.style.left = `${nx / rect.width * 100}%`;
                item.element.style.top = `${ny / rect.height * 100}%`;

                if (dist < 30) { // Collected
                    item.active = false;
                    item.element.style.display = 'none';

                    if (item.type === 'good') {
                        this.score++;
                        if (this.score >= this.targetScore) {
                            this.win();
                        }
                    } else {
                        this.lose();
                    }
                }
            }
        });
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
        this.engine.input.element.removeEventListener('pointercancel', this.onUp);
    }
}
